import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import styles from "./BrowserCompatibility.module.scss";

const BrowserCompatibility: React.FC = () => {
    return (
        <Container className={`${styles.container}`}>
            <Row className={`justify-content-center align-items-center`}>
                <Col className="text-center">
                    <h1 className="heading">Browser Compatibility</h1>
                </Col>
            </Row>

            <Row className={`${styles.customeRowHeight} justify-content-center`}>
                <Col                
                    className = "text-center text-secondary">
                    <p>Sorry, this site does not currently support your browser.</p>
                    <p>
                        In order for 1link to operate securely and efficiently, we support specific widely used browsers only.<br />
                        This allows us to ensure that they meet our security and compatibility criteria.
                    </p>
                    <p>&nbsp;</p>
                    <p>Our support team will be able to advise you of the current requirements for 1link.</p>
                    <p>Dealers should call 1link on <strong>0870 011 8800</strong>.</p>
                    <p>Other users should call 1link on <strong>0845 230 5406</strong>.</p>
                </Col>
            </Row>
        </Container>
    );
};

export default BrowserCompatibility;
